namespace $.$$ {

	/** Приватный реестр устройств пользователя. */
	export class $bog_gram_devices extends $giper_baza_dict.with({
		Registry: $giper_baza_dict_to( $bog_gram_device ),
	}) {}

}
